let InsertPosition = /*#__PURE__*/function (InsertPosition) {
  InsertPosition[InsertPosition["BEFORE"] = 1] = "BEFORE";
  InsertPosition[InsertPosition["AFTER"] = 2] = "AFTER";
  return InsertPosition;
}({});

const getNestedTreeIds = item => {
  let ids = [item.id];
  if (item.items && item.items.length) {
    for (const nestedItem of item.items) {
      ids = [...ids, ...getNestedTreeIds(nestedItem)];
    }
  }
  return ids;
};
const getCheckedNestedTreeIds = (nestedTreeIds, checkedTreeIds) => {
  if (!checkedTreeIds.length || !nestedTreeIds.length) return [];
  return checkedTreeIds.filter(checkedId => nestedTreeIds.includes(checkedId));
};
const removeTreeItem = (treeData, targetItem) => {
  let newData = JSON.parse(JSON.stringify(treeData));
  for (const item of newData) {
    if (item.id === targetItem.id) {
      newData = newData.filter(node => node.id !== targetItem.id);
      break;
    }
    if (item.items && item.items.length) {
      item.items = removeTreeItem(item.items, targetItem);
    }
  }
  return newData;
};
const addTreeItem = (treeData, targetItem, newItem, insertPosition) => {
  const newData = JSON.parse(JSON.stringify(treeData));
  for (let i = 0; i < newData.length; i += 1) {
    if (newData[i].id === targetItem.id) {
      const insertIndex = insertPosition === InsertPosition.AFTER ? i + 1 : i;
      newData.splice(insertIndex, 0, newItem);
      break;
    }
    const nestedItems = newData[i].items;
    if (nestedItems && nestedItems.length) {
      newData[i].items = addTreeItem(nestedItems, targetItem, newItem, insertPosition);
    }
  }
  return newData;
};
const itemContainsTarget = (targetItem, item) => {
  const nestedTreeIds = getNestedTreeIds(item);
  return nestedTreeIds.includes(targetItem.id);
};

export { InsertPosition as I, addTreeItem as a, getCheckedNestedTreeIds as b, getNestedTreeIds as g, itemContainsTarget as i, removeTreeItem as r };
